import BaseActionCableConnector from '../../shared/helpers/BaseActionCableConnector';
import { playCustomAudio } from '../../shared/helpers/AudioNotificationHelper';
import { CHATBOTS_GAINSIGHT_EVENTS, handleChatBotGainSight, handleLiveChatConvTriggerEvent } from '../../gainSightIntegration';

const isMessageInActiveConversation = (getters, message) => {
  const { conversation_id: conversationId } = message;
  const activeConversationId =
    getters['conversationAttributes/getConversationParams']?.id;
  return activeConversationId !== undefined && conversationId !== activeConversationId;
};

class ActionCableConnector extends BaseActionCableConnector {
  constructor(app, pubsubToken) {
    const { websocketURL = '' } = window.chatwootConfig || {};
    super(app, pubsubToken, websocketURL);
    this.events = {
      'message.created': this.onMessageCreated,
      'message.updated': this.onMessageUpdated,
      'conversation.typing_on': this.onTypingOn,
      'conversation.typing_off': this.onTypingOff,
      'conversation.status_changed': this.onStatusChange,
      'conversation.created': this.onConversationCreated,
      'conversation.updated': this.onConversationUpdated, 
      'presence.update': this.onPresenceUpdate,
    };
  }

  onStatusChange = data => {
    handleChatBotGainSight(CHATBOTS_GAINSIGHT_EVENTS.CHATBOT_CLOSED_CHAT, data);
    this.app.$store.dispatch('conversationAttributes/update', data);
  };

  onConversationCreated = data => {
    handleLiveChatConvTriggerEvent(data);
    this.app.$store.dispatch('conversationAttributes/update', data);
  };

  onConversationUpdated = data => {
    handleChatBotGainSight(CHATBOTS_GAINSIGHT_EVENTS.CHAT_HANDOFF_TO_AGENT, data);
    this.app.$store.dispatch('conversationAttributes/update', data);
  };

  onMessageCreated = data => {
    if (isMessageInActiveConversation(this.app.$store.getters, data)) {
      return;
    }

    const hiverConfig = this.app.$store.getters[
      'hiverConfig/getHiverConfig'
    ];

    this.app.$store
      .dispatch('conversation/addOrUpdateMessage', data)
      .then(() => {
          window.bus.$emit('on-agent-message-recieved');
          if (data && data.sender_type !== 'Contact' &&  !hiverConfig?.disable_widget_notifications) {
              playCustomAudio('assigned-chat-new-message.wav');
          }
      });
  };

  onMessageUpdated = data => {
    if (isMessageInActiveConversation(this.app.$store.getters, data)) {
      return;
    }
    this.app.$store.dispatch('conversation/addOrUpdateMessage', data);
  };

  onPresenceUpdate = data => {
    this.app.$store.dispatch('agent/updatePresence', data.users);
  };

  onTypingOn = () => {
    this.clearTimer();
    this.app.$store.dispatch('conversation/toggleAgentTyping', {
      status: 'on',
    });
    this.initTimer();
  };

  onTypingOff = () => {
    this.clearTimer();
    this.app.$store.dispatch('conversation/toggleAgentTyping', {
      status: 'off',
    });
  };

  clearTimer = () => {
    if (this.CancelTyping) {
      clearTimeout(this.CancelTyping);
      this.CancelTyping = null;
    }
  };

  initTimer = () => {
    // Turn off typing automatically after 30 seconds
    this.CancelTyping = setTimeout(() => {
      this.onTypingOff();
    }, 30000);
  };
}

export default ActionCableConnector;
